/**
 * Definição de todos os recursos possíveis nos planos.
 * Quando o admin marca um recurso como disponível para um plano, ele aparece na tabela para os clientes.
 */
import { Users, Layout, UploadCloud, Image as ImageIcon, Puzzle, Sparkles, Save, HardDrive, KeyRound, Lamp } from 'lucide-react';

/** Chaves de tradução para planFeatures (plans namespace) */
export const PLAN_LABEL_KEYS = {
  'storage_projects_mb': 'storageProjectsMb',
  'storage_logs_mb': 'storageLogsMb',
  'storage_media_mb': 'storageMediaMb',
  'max_collaborators_editor': 'collaboratorsEditors',
  'max_collaborators_viewer': 'collaboratorsViewers',
  'save': 'saveLayout',
  'grid:1/1': 'grid100',
  'grid:1/2': 'grid5050',
  'grid:1/3': 'grid333',
  'grid:1/4': 'grid25',
  'grid:2/3': 'grid6633',
  'grid:33/66': 'grid3366',
  'grid:dynamic': 'gridDynamic',
  'element:text': 'text',
  'element:title-basic': 'titleBasic',
  'element:image': 'image',
  'element:video': 'video',
  'element:panda-video': 'pandaVideo',
  'element:h5p': 'h5p',
  'element:styled-button': 'button',
  'element:page-break': 'pageBreak',
  'element:list-icon': 'listIcons',
  'element:tabs': 'tabs',
  'element:accordion': 'accordion',
  'element:divider': 'divider',
  'element:htmlTemplate': 'htmlTemplate',
  'element:styled-card': 'styledCard',
  'element:alert': 'alert',
  'element:section-header': 'sectionHeader',
  'element:modal-trigger': 'modal',
    'element:carousel': 'carousel',
    'element:card-slider': 'cardSlider',
    'element:card-shop': 'cardShop',
  'element:video-card-slider': 'videoCardSlider',
  'element:image-card': 'imageCard',
  'element:social-card': 'socialCard',
  'element:post-it': 'postIt',
  'element:blockquote': 'blockquote',
  'element:moodle-activity': 'openMoodleActivity',
  'element:timeline': 'timeline',
  'element:checkpoint': 'checkpoint',
  'element:reinforcement-quiz': 'reinforcementQuiz',
  'element:progress-bar': 'progressBar',
  'element:header-menu': 'headerMenu',
  'element:site-menu': 'siteMenu',
  'element:site-footer': 'siteFooter',
  'element:site-login': 'siteLogin',
  'element:site-maintenance': 'siteMaintenance',
  'element:count-up': 'countUp',
  'element:comments': 'comments',
  'element:geppetto-backpack': 'backpack',
  'element:spacer': 'spacer',
  'element:responsive-table': 'responsiveTable',
  'element:image-gallery': 'imageGallery',
  'element:chart-widget': 'chartWidget',
  'element:flowchart-widget': 'flowchartWidget',
  'element:asaas-payment': 'asaasPayment',
  'element:mercadopago-payment': 'mercadopagoPayment',
  'module:plugin': 'plugin',
  'module:myApi': 'myApi',
  'module:upload': 'uploadImages',
  'module:midias': 'globalMedia',
  'module:indique': 'referral',
  'module:cricket': 'cricket',
};

export const ALL_GRIDS = [
  { id: '1/1', label: 'Grid 100%' },
  { id: '1/2', label: 'Grid 50/50' },
  { id: '1/3', label: 'Grid 33/33/33' },
  { id: '1/4', label: 'Grid 25/25/25/25' },
  { id: '2/3', label: 'Grid 66/33' },
  { id: '33/66', label: 'Grid 33/66' },
  { id: 'dynamic', label: 'Grid Dinâmico' },
];

export const ALL_ELEMENTS = [
  { id: 'text', label: 'Texto' },
  { id: 'title-basic', label: 'Título âncora' },
  { id: 'image', label: 'Imagem' },
  { id: 'video', label: 'Vídeo' },
  { id: 'panda-video', label: 'Panda Vídeo' },
  { id: 'h5p', label: 'H5P ou Genially' },
  { id: 'styled-button', label: 'Botão CTA' },
  { id: 'page-break', label: 'Paginação' },
  { id: 'list-icon', label: 'Lista Ícones' },
  { id: 'tabs', label: 'Abas' },
  { id: 'accordion', label: 'Accordion' },
  { id: 'divider', label: 'Linha' },
  { id: 'htmlTemplate', label: 'Template HTML' },
  { id: 'styled-card', label: 'Card Estilizado' },
  { id: 'alert', label: 'Aviso/Alert' },
  { id: 'section-header', label: 'Cabeçalho' },
  { id: 'modal-trigger', label: 'Modal' },
  { id: 'carousel', label: 'Carrossel' },
  { id: 'card-slider', label: 'Carrossel de cards' },
  { id: 'card-shop', label: 'Card Shop' },
  { id: 'video-card-slider', label: 'Carrossel de vídeos' },
  { id: 'image-card', label: 'Image Card' },
  { id: 'social-card', label: 'Social Card' },
  { id: 'post-it', label: 'Post-it' },
  { id: 'blockquote', label: 'Citação' },
  { id: 'moodle-activity', label: 'Abrir atividade Moodle' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'checkpoint', label: 'Checkpoint' },
  { id: 'reinforcement-quiz', label: 'Quiz de reforço' },
  { id: 'progress-bar', label: 'Barra Progresso' },
  { id: 'header-menu', label: 'Menu cabeçalho' },
  { id: 'site-menu', label: 'Menu Site' },
  { id: 'site-footer', label: 'Rodapé do site' },
  { id: 'site-login', label: 'Página de login' },
  { id: 'site-maintenance', label: 'Modo manutenção' },
  { id: 'count-up', label: 'Número crescente' },
  { id: 'comments', label: 'Comentários' },
  { id: 'geppetto-backpack', label: 'Bloco de anotações' },
  { id: 'spacer', label: 'Espaçador' },
  { id: 'countdown', label: 'Contador regressivo' },
  { id: 'responsive-table', label: 'Tabela responsiva' },
  { id: 'image-gallery', label: 'Galeria de imagens' },
  { id: 'chart-widget', label: 'Gráficos' },
  { id: 'flowchart-widget', label: 'Fluxograma' },
  { id: 'table-of-contents', label: 'Sumário' },
  { id: 'asaas-payment', label: 'Pagamento Asaas' },
  { id: 'mercadopago-payment', label: 'Pagamento Mercado Pago' },
];

export const ELEMENTOS_BASIC = ['text', 'title-basic', 'image', 'video', 'panda-video', 'h5p', 'styled-button', 'page-break', 'spacer', 'countdown'];
export const ELEMENTOS_EXPERT = ['list-icon', 'tabs', 'accordion', 'divider', 'htmlTemplate', 'responsive-table', 'table-of-contents', 'site-maintenance'];

/** Elementos sempre permitidos no plano grátis (uso/export), mesmo com tier Expert/Premium. */
export const FREE_PLAN_ALWAYS_UNLOCKED_ELEMENTS = new Set(['progress-bar', 'checkpoint']);

/** Sempre liberados no plano pago (header / casos especiais). */
export const HEADER_ALWAYS_ELEMENTS = ['progress-bar', 'checkpoint', 'htmlTemplate'];

/** Ordem das categorias na UI (Básico sem ícone, Expert 🪄, Premium 👑). */
export const ELEMENT_TIER_ORDER = ['basic', 'expert', 'premium'];

/** Índice do tier na ordem (desconhecido → 0 / basic). */
export function elementTierIndex(tier) {
  const i = ELEMENT_TIER_ORDER.indexOf(tier);
  return i < 0 ? 0 : i;
}

/**
 * Teto de categoria do plano (ceiling).
 * Preferência: max_element_tier → maior de element_categories → null (path legado).
 * @returns {'basic'|'expert'|'premium'|null}
 */
export function resolveMaxElementTier(planFeatures) {
  const f = planFeatures || {};
  const explicit = f.max_element_tier;
  if (typeof explicit === 'string' && ELEMENT_TIER_ORDER.includes(explicit)) {
    return explicit;
  }
  const categories = f.element_categories;
  if (!Array.isArray(categories) || categories.length === 0) {
    return null;
  }
  let maxIdx = -1;
  for (const c of categories) {
    const i = ELEMENT_TIER_ORDER.indexOf(c);
    if (i > maxIdx) maxIdx = i;
  }
  return maxIdx < 0 ? null : ELEMENT_TIER_ORDER[maxIdx];
}

/** Prefixos até o teto (expert → ['basic','expert']). */
export function categoriesUpToMaxTier(maxTier) {
  if (!maxTier || !ELEMENT_TIER_ORDER.includes(maxTier)) return [];
  return ELEMENT_TIER_ORDER.slice(0, elementTierIndex(maxTier) + 1);
}

/** Catálogo padrão: basic | expert | premium */
export function getElementTier(elementId) {
  if (ELEMENTOS_BASIC.includes(elementId)) return 'basic';
  if (ELEMENTOS_EXPERT.includes(elementId)) return 'expert';
  return 'premium';
}
export const ELEMENTOS_PREMIUM = ['styled-card', 'alert', 'section-header', 'modal-trigger', 'carousel', 'card-slider', 'card-shop', 'video-card-slider', 'image-card', 'social-card', 'post-it', 'blockquote', 'moodle-activity', 'timeline', 'checkpoint', 'reinforcement-quiz', 'progress-bar', 'header-menu', 'site-menu', 'site-footer', 'site-login', 'count-up', 'comments', 'image-gallery', 'chart-widget', 'flowchart-widget', 'asaas-payment', 'mercadopago-payment'];

/** Monta mapa elementId → tier a partir das listas legadas expert/premium das feature flags. */
function buildElementTiersFromLegacyFlags(flags) {
  const tiers = Object.fromEntries(ALL_ELEMENTS.map((e) => [e.id, 'basic']));
  for (const id of flags.expert || []) {
    if (tiers[id] !== undefined) tiers[id] = 'expert';
  }
  for (const id of flags.premium || []) {
    if (tiers[id] !== undefined) tiers[id] = 'premium';
  }
  if ((flags.premium || []).includes('moodle-activity') || (flags.premium || []).includes('moodle-quiz') || (flags.premium || []).includes('moodle-forum')) {
    tiers['moodle-activity'] = 'premium';
    tiers['moodle-quiz'] = 'premium';
    tiers['moodle-forum'] = 'premium';
  }
  return tiers;
}

/**
 * Mapa efetivo id → tier (defaults do código + `elementTiers` salvo ou listas expert/premium legadas).
 * @param {object} flags — objeto `feature_flags` (ou fragmento) do backend
 */
export function getMergedElementTiers(flags = {}) {
  const defaults = Object.fromEntries(ALL_ELEMENTS.map((e) => [e.id, getElementTier(e.id)]));
  if (flags.elementTiers && typeof flags.elementTiers === 'object' && Object.keys(flags.elementTiers).length > 0) {
    return { ...defaults, ...flags.elementTiers };
  }
  if ((flags.expert && flags.expert.length) || (flags.premium && flags.premium.length)) {
    return { ...defaults, ...buildElementTiersFromLegacyFlags(flags) };
  }
  return defaults;
}

/** Mapa grid id → tier a partir de premiumGrids / trialGrids legados. */
function buildGridTiersFromLegacy(flags) {
  const tiers = Object.fromEntries(ALL_GRIDS.map((g) => [g.id, 'basic']));
  for (const id of flags.premiumGrids || []) {
    if (tiers[id] !== undefined) tiers[id] = 'premium';
  }
  for (const id of flags.trialGrids || []) {
    if (tiers[id] !== undefined && tiers[id] !== 'premium') tiers[id] = 'expert';
  }
  return tiers;
}

/**
 * Classificação global dos modelos de grid (Básico / Expert / Premium na gaveta e plano grátis).
 */
export function getMergedGridTiers(flags = {}) {
  const defaults = Object.fromEntries(ALL_GRIDS.map((g) => [g.id, 'basic']));
  if (flags.gridTiers && typeof flags.gridTiers === 'object' && Object.keys(flags.gridTiers).length > 0) {
    return { ...defaults, ...flags.gridTiers };
  }
  if ((flags.premiumGrids && flags.premiumGrids.length) || (flags.trialGrids && flags.trialGrids.length)) {
    return { ...defaults, ...buildGridTiersFromLegacy(flags) };
  }
  return defaults;
}

function buildModuleTiersFromLegacy(flags) {
  const ids = ALL_MODULES.map((m) => m.id);
  const tiers = Object.fromEntries(ids.map((id) => [id, 'basic']));
  for (const id of flags.premiumModules || []) {
    if (tiers[id] !== undefined) tiers[id] = 'premium';
  }
  for (const id of flags.trialModules || []) {
    if (tiers[id] !== undefined && tiers[id] !== 'premium') tiers[id] = 'expert';
  }
  return tiers;
}

/**
 * Classificação global dos módulos do menu lateral (ícones / plano grátis).
 */
export function getMergedModuleTiers(flags = {}) {
  const defaults = Object.fromEntries(ALL_MODULES.map((m) => [m.id, 'basic']));
  if (flags.moduleTiers && typeof flags.moduleTiers === 'object' && Object.keys(flags.moduleTiers).length > 0) {
    return { ...defaults, ...flags.moduleTiers };
  }
  if ((flags.premiumModules && flags.premiumModules.length) || (flags.trialModules && flags.trialModules.length)) {
    return { ...defaults, ...buildModuleTiersFromLegacy(flags) };
  }
  return defaults;
}

/**
 * Conjunto de elementos permitidos pelo plano (pago ou colaborador).
 * - Com teto (`max_element_tier` ou `element_categories`): tudo com tier ≤ teto + `element_extra_ids`.
 * - Legado (sem categorias): todos de tier básico + `features.elements`.
 * O palco/canvas NÃO usa esta função para bloquear inserção — só export / save cloud / validate.
 */
/**
 * @param {object} planFeatures
 * @param {object} tierMap
 * @param {{ injectHeaderAlways?: boolean }} [options] — na tabela de planos do perfil use `injectHeaderAlways: false` para refletir só o que o admin gravou no plano.
 */
/** `moodle-activity` e blocos antigos quiz/fórum compartilham permissão. */
function expandMoodleActivityElementCompat(allowed) {
  if (allowed.has('moodle-activity') || allowed.has('moodle-quiz') || allowed.has('moodle-forum')) {
    allowed.add('moodle-activity');
    allowed.add('moodle-quiz');
    allowed.add('moodle-forum');
  }
}

export function resolvePlanAllowedElements(planFeatures, tierMap, options = {}) {
  const { injectHeaderAlways = true } = options;
  const f = planFeatures || {};
  const allowed = new Set();
  if (injectHeaderAlways) {
    HEADER_ALWAYS_ELEMENTS.forEach((id) => allowed.add(id));
  }

  const legacyPick = Array.isArray(f.elements) ? f.elements : [];
  const extras = Array.isArray(f.element_extra_ids) ? f.element_extra_ids : [];
  const maxTier = resolveMaxElementTier(f);

  if (maxTier) {
    const maxIdx = elementTierIndex(maxTier);
    for (const e of ALL_ELEMENTS) {
      const tier = tierMap[e.id] || getElementTier(e.id);
      if (elementTierIndex(tier) <= maxIdx) allowed.add(e.id);
    }
    for (const id of extras) allowed.add(id);
    expandMoodleActivityElementCompat(allowed);
    return allowed;
  }

  for (const e of ALL_ELEMENTS) {
    const tier = tierMap[e.id] || getElementTier(e.id);
    if (tier === 'basic') allowed.add(e.id);
  }
  for (const id of legacyPick) allowed.add(id);
  expandMoodleActivityElementCompat(allowed);
  return allowed;
}

/**
 * Deriva estado inicial do modal de plano (categorias + extras) a partir de `features` gravadas.
 * Normaliza categorias para o prefixo do teto (ceiling), evitando estados esparsos legados.
 */
export function deriveElementCategoryStateFromPlan(planFeatures, tierMap) {
  const f = planFeatures || {};
  const maxTier = resolveMaxElementTier(f);
  if (maxTier) {
    const categories = categoriesUpToMaxTier(maxTier);
    const extras = [...(f.element_extra_ids || [])].filter((id) => {
      const t = tierMap[id] || getElementTier(id);
      return elementTierIndex(t) > elementTierIndex(maxTier);
    });
    return {
      element_categories: categories,
      element_extra_ids: extras,
    };
  }
  if (Array.isArray(f.element_categories)) {
    return {
      element_categories: [],
      element_extra_ids: [...(f.element_extra_ids || [])],
    };
  }
  const legacyAllowed = resolvePlanAllowedElements(f, tierMap);
  const categories = [];
  for (const tier of ELEMENT_TIER_ORDER) {
    const idsInTier = ALL_ELEMENTS.filter((e) => (tierMap[e.id] || getElementTier(e.id)) === tier).map((e) => e.id);
    if (idsInTier.length && idsInTier.every((id) => legacyAllowed.has(id))) {
      categories.push(tier);
    }
  }
  // Ceiling: se há gaps, usa o maior tier contínuo desde basic.
  let maxIdx = -1;
  for (let i = 0; i < ELEMENT_TIER_ORDER.length; i++) {
    if (categories.includes(ELEMENT_TIER_ORDER[i])) maxIdx = i;
    else break;
  }
  const normalized = maxIdx < 0 ? [] : ELEMENT_TIER_ORDER.slice(0, maxIdx + 1);
  const headerSet = new Set(HEADER_ALWAYS_ELEMENTS);
  const extra = [...legacyAllowed].filter((id) => {
    if (headerSet.has(id)) return false;
    const t = tierMap[id] || getElementTier(id);
    if (!normalized.length) return true;
    return elementTierIndex(t) > maxIdx;
  });
  return { element_categories: normalized, element_extra_ids: extra };
}

export const ALL_MODULES = [
  { id: 'plugin', label: 'Plugin Moodle', icon: Puzzle },
  { id: 'myApi', label: 'Minha API', icon: KeyRound },
  { id: 'upload', label: 'Upload de imagens', icon: UploadCloud },
  { id: 'midias', label: 'Mídias globais', icon: ImageIcon },
  { id: 'indique', label: 'Indique e Ganhe', icon: Sparkles },
  { id: 'cricket', label: 'Cricket (quadro de tarefas)', icon: Lamp },
];

/**
 * Limite de projetos (canvas) persistidos na nuvem para o plano.
 * - save: true (legado) = ilimitado
 * - save: número ≥ 0 = quantidade máxima (pastas não entram)
 */
export function getPlanSaveSlotLimit(features) {
  if (!features || typeof features !== 'object') return 0;
  const s = features.save;
  if (s === true) return Infinity;
  const n = parseInt(s, 10);
  if (Number.isFinite(n) && n >= 0) return n;
  return 0;
}

/** Quantidade de layouts “canvas” na lista da gaveta (exclui pastas). */
export function countCanvasProjectsInList(projectsList) {
  return (projectsList || []).filter((p) => p && p.type !== 'folder' && p.type !== 'Folder').length;
}

/**
 * Limite de slots atingido ao tentar criar um novo projeto na nuvem (não bloqueia atualização de projeto já salvo).
 */
export function isAtSavedLayoutSlotCapacity({ features, projectsList, courseInfo }) {
  const limit = getPlanSaveSlotLimit(features);
  if (limit === 0 || !Number.isFinite(limit)) return false;
  const n = countCanvasProjectsInList(projectsList);
  const id = courseInfo?.id;
  if (id && (projectsList || []).some((p) => p && p.id === id && p.type !== 'folder' && p.type !== 'Folder')) {
    return false;
  }
  return n >= limit;
}

/** Estrutura para seções colapsáveis da tabela (tierMap = classificação global do admin). */
export function buildFeatureSections(plans, tierMapOpt) {
  const tierMap = tierMapOpt || Object.fromEntries(ALL_ELEMENTS.map((e) => [e.id, getElementTier(e.id)]));
  const gridIds = new Set();
  const elementIds = new Set();
  const moduleIds = new Set();

  plans.forEach((p) => {
    const f = p.features || {};
    (f.grids || []).forEach((id) => gridIds.add(id));
    resolvePlanAllowedElements(f, tierMap, { injectHeaderAlways: false }).forEach((id) => elementIds.add(id));
    const mods = f.modules || {};
    Object.keys(mods).forEach((id) => {
      if (mods[id] === true) moduleIds.add(id);
    });
  });

  const gridItems = ALL_GRIDS.filter((g) => gridIds.has(g.id)).map((g) => ({ key: `grid:${g.id}`, label: g.label, icon: Layout, type: 'bool' }));
  const moduleRows = ALL_MODULES.filter((m) => moduleIds.has(m.id)).map((m) => ({ key: `module:${m.id}`, label: m.label, icon: m.icon, type: 'bool' }));

  const elementsByTier = {
    basic: ALL_ELEMENTS.filter((e) => tierMap[e.id] === 'basic' && elementIds.has(e.id)).map((e) => ({ key: `element:${e.id}`, label: e.label, icon: Layout, type: 'bool' })),
    expert: ALL_ELEMENTS.filter((e) => tierMap[e.id] === 'expert' && elementIds.has(e.id)).map((e) => ({ key: `element:${e.id}`, label: e.label, icon: Layout, type: 'bool' })),
    premium: ALL_ELEMENTS.filter((e) => tierMap[e.id] === 'premium' && elementIds.has(e.id)).map((e) => ({ key: `element:${e.id}`, label: e.label, icon: Layout, type: 'bool' })),
  };

  // Não exibir max_projects — limite por quantidade de projetos descontinuado na UI; uso por espaço em disco (cotas MB).
  const baseRows = [
    { key: 'storage_projects_mb', label: 'Cota dados de projetos (MB)', icon: HardDrive, type: 'storage_mb' },
    { key: 'storage_logs_mb', label: 'Cota logs de atividade (MB)', icon: HardDrive, type: 'storage_mb' },
    { key: 'storage_media_mb', label: 'Cota biblioteca de mídias (MB)', icon: HardDrive, type: 'storage_mb' },
    { key: 'max_collaborators_editor', label: 'Editores (colaboradores)', icon: Users, type: 'number' },
    { key: 'max_collaborators_viewer', label: 'Visualizadores', icon: Users, type: 'number' },
    { key: 'save', label: 'Salvar layout no palco (máx. projetos)', icon: Save, type: 'number' },
  ].filter((f) => f.key !== 'max_users');

  return {
    base: baseRows,
    grid: { label: 'Grids (modelos de layout)', items: gridItems },
    elementos: {
      basic: { label: 'Elementos Basic', items: elementsByTier.basic },
      expert: { label: 'Elementos Expert', items: elementsByTier.expert },
      premium: { label: 'Elementos Premium', items: elementsByTier.premium },
    },
    modules: moduleRows,
  };
}

/** Retorna lista de features para a tabela (legado, flat) */
export function buildFeatureRows(plans) {
  const s = buildFeatureSections(plans);
  const all = [...s.base];
  if (s.grid.items.length) all.push(...s.grid.items);
  s.elementos.basic.items.forEach((e) => all.push(e));
  s.elementos.expert.items.forEach((e) => all.push(e));
  s.elementos.premium.items.forEach((e) => all.push(e));
  all.push(...s.modules);
  return all;
}

/** Verifica se o plano tem limitação em um grupo (menos itens que o máximo) */
export function hasLimitationInGroup(plans, items, getValue) {
  if (!items?.length) return () => false;
  const maxCount = Math.max(...plans.map((p) => items.filter((it) => getValue(p, it)).length));
  return (plan) => items.filter((it) => getValue(plan, it)).length < maxCount;
}

/** Obtém o valor de uma feature para um plano (tierMap opcional = classificação global do admin). */
export function getPlanFeatureValue(plan, feat, tierMapOpt) {
  const defaultMap = Object.fromEntries(ALL_ELEMENTS.map((e) => [e.id, getElementTier(e.id)]));
  const tierMap = tierMapOpt || defaultMap;
  const planTableElementOpts = { injectHeaderAlways: false };

  if (feat.key === 'storage_projects_mb') {
    const v = plan.storage_projects_mb;
    return v == null ? 'unlimited' : `${v} MB`;
  }
  if (feat.key === 'storage_logs_mb') {
    const v = plan.storage_logs_mb;
    return v == null ? 'unlimited' : `${v} MB`;
  }
  if (feat.key === 'storage_media_mb') {
    const v = plan.storage_media_mb;
    return v == null ? 'unlimited' : `${v} MB`;
  }
  if (feat.key === 'max_collaborators_editor') return plan.features?.max_collaborators_editor ?? 0;
  if (feat.key === 'max_collaborators_viewer') return plan.features?.max_collaborators_viewer ?? 0;
  if (feat.key === 'save') {
    const lim = getPlanSaveSlotLimit(plan.features || {});
    if (lim === Infinity) return 'unlimited';
    return lim;
  }

  if (feat.key.startsWith('grid:')) {
    const id = feat.key.replace('grid:', '');
    return (plan.features?.grids || []).includes(id);
  }
  if (feat.key.startsWith('element:')) {
    const id = feat.key.replace('element:', '');
    return resolvePlanAllowedElements(plan.features || {}, tierMap, planTableElementOpts).has(id);
  }
  if (feat.key.startsWith('module:')) {
    const id = feat.key.replace('module:', '');
    return plan.features?.modules?.[id] === true;
  }
  return false;
}

/** Espelha planAllowsMyApiMenu (backend): Minha API e gateways de pagamento no builder/perfil. */
export function planAllowsMyApiMenuClient(features) {
  const m = features?.modules || {};
  if (m.myApi === false) return false;
  if (m.myApi === true) return true;
  return m.plugin === true;
}

/** Módulo Plugins Moodle incluído no plano (tabela de planos: modules.plugin === true). */
export function planPluginModuleActiveClient(features) {
  return features?.modules?.plugin === true;
}

/** Módulo «Upload de imagens» incluído no plano (tabela de planos: modules.upload === true). */
export function planUploadModuleActiveClient(features) {
  return features?.modules?.upload === true;
}

/** Módulo Cricket (quadro estilo Kanban / vínculo com elementos): modules.cricket === true. */
export function planCricketModuleActiveClient(features) {
  return features?.modules?.cricket === true;
}
